export class WebPushStorage {
    static readonly key: string = 'simpleStorage';
    static readonly storageId: string = 'pushNotification';
    private searches: any;
    private pushUserId: any;

    constructor() {
        this.searches = this.getSearches()
        this.pushUserId = this.getPushUserId();
    }

    public getSearch(search: string) {
        return this.searches[search];
    }

    public saveSearch(search: string) {
        this.searches[search] = true;
        this.saveStorage()
    }

    public getPushUserId(): string {
        let storage = this.getStorageKey();
        if (!storage) {
            this.setLocalStorageId();
            storage = this.getStorageKey();
        }
        if (!storage[WebPushStorage.storageId]) {
            this.setLocalStorageId();
        }
        storage = this.getStorageKey();

        return storage[WebPushStorage.storageId].pushUserId || '';
    }

    public savePushUserId(pushUserId: string) {
        this.pushUserId = pushUserId;
        this.saveStorage()
    }

    public clearAllSearches() {
        this.searches = {};
        this.saveStorage();
    }

    private getSearches() {
        let storage = this.getStorageKey();
        if (!storage) {
            this.setLocalStorageId();
            storage = this.getStorageKey();
        }
        if (!storage[WebPushStorage.storageId]) {
            this.setLocalStorageId();
        }
        storage = this.getStorageKey();

        return storage[WebPushStorage.storageId].searches;
    }

    private getStorageKey() {
        return JSON.parse(<string>window.localStorage.getItem(WebPushStorage.key));
    }

    private setLocalStorageId() {
        window.localStorage.setItem(WebPushStorage.key,
            JSON.stringify({[WebPushStorage.storageId]: {"id": [WebPushStorage.storageId], "searches": {}}}));
    }

    private saveStorage() {
        let storage = this.getStorageKey();
        storage[WebPushStorage.storageId].searches = this.searches;
        storage[WebPushStorage.storageId].pushUserId = this.pushUserId;
        window.localStorage.setItem(WebPushStorage.key, JSON.stringify(storage));
    }
}